@let inBurger = host() === HOSTS.BURGER;
@let menuMode = inBurger ? 'collapse' : 'dropdown';
@let fullWidth = inBurger ? true : false;
@let buttonPadding = inBurger ? '0.75rem' : '0.6rem';

@let isPublicMode = mode() === MODES.PUBLIC;

<ng-content select="[extra-settings]" />

<nav class="section section--start">
  <!-- help -->
  @let menuHelp = help();
  @if (!isPublicMode) {
    @let title = ('menus.help.title' | platformTranslate)();
    <evc-menu
      class="menu menu--help"
      data-testid="help-menu"
      position="bottom-right"
      [items]="menuHelp?.items ?? []"
      [title]="title"
      [mode]="menuMode">
      <evc-button
        trigger
        evcMenuTriggerState
        class="trigger button button--help"
        [frame]="buttonFrame()"
        [type]="buttonType()"
        size="small"
        icon="help"
        style="--button-padding: {{ buttonPadding }}"
        [fullWidth]="fullWidth">
        @if (inBurger) {
          <span class="button__label">{{ title }}</span>
          <evc-icon
            class="button__toggle"
            size="md"
            icon="chevron-down" />
        }
      </evc-button>
    </evc-menu>
  }

  <!-- settings -->
  @let menuSettings = settings();
  @if (!isPublicMode && menuSettings?.items?.length) {
    @let title = ('menus.settings.title' | platformTranslate)();
    <evc-menu
      class="menu menu--settings"
      data-testid="settings-menu"
      position="bottom-right"
      [items]="menuSettings!.items!"
      [title]="title"
      [mode]="menuMode">
      <evc-button
        trigger
        evcMenuTriggerState
        class="trigger button button--settings"
        frame="ghost"
        size="small"
        icon="settings-alt"
        style="--button-padding: 0.6rem"
        [fullWidth]="fullWidth">
        @if (inBurger) {
          <span class="button__label">{{ title }}</span>
          <evc-icon
            class="button__toggle"
            size="md"
            icon="chevron-down" />
        }
      </evc-button>
      <!-- TODO CLOUD-1183: inject a newly created theme-selector component here
        then remove from default config service
        => new ui and see with arnaud about menu title that become theme :( -->
    </evc-menu>
  }
</nav>

<!-- extra bottom slot -->
<ng-content
  class="extra"
  select="[extra-content]" />
<ng-content
  class="after"
  select="[content-after]" />

<div class="section section--end">
  <!-- user -->
  @if (user()) {
    <evc-user-menu
      class="button button--user"
      [isIms]="isIms()"
      [layout]="mode()"
      [host]="host()"
      [login]="login()"
      [logout]="logout()"
      [changeOrganization]="changeOrganization()" />
  }

  <!-- lang -->
  @let menuLang = langs();
  @if (isPublicMode && (menuLang?.items ?? []).length > 0) {
    <evc-menu
      class="menu menu--lang"
      data-testid="lang-menu"
      [items]="menuLang!.items!"
      [title]="(menuLang!.title | optionalAsync) ?? undefined"
      [position]="inBurger ? 'top-right' : 'bottom-right'">
      <evc-button
        trigger
        evcMenuTriggerState
        class="trigger button button--lang lang-switcher"
        icon="chevron-down"
        iconPosition="right"
        size="small"
        frame="none"
        [text]="lang()?.toUpperCase() ?? ''" />
    </evc-menu>
  }
</div>
